import { createSlug } from './create-slug';
import { MANUAL_ORDER_TYPES, NUVEM_ENVIO_CARRIERS } from '../pages/constants';

export const isNuvemEnvioCarrier = (carrier: string, shipping: string) => {
  const carrierSlug = createSlug(carrier);
  const shippingSlug = createSlug(shipping);
  return (
    NUVEM_ENVIO_CARRIERS.some((substring) => carrierSlug.includes(substring)) ||
    MANUAL_ORDER_TYPES.includes(shippingSlug)
  );
};
